import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { Toast } from '../../components/Toast';
import { AppHelper } from '../../helpers/AppHelper';
export class CampaignsSelfServe extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'campaignsSelfServe'
    this.pageTitle = Helper.getString('campaignsSelfServe')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'ss-campaigns'] },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.title}</span>
            <br/>
            <span className={css(Styles.spanValue)}>{current.org && current.org.title}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Campaign Id: {current.id}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Created: {Helper.formatTimestamp(current.createdTs)}</span>
            <br/>
            {/* <span className={css(Styles.spanValue, Styles.line2)}>Duration: {Helper.formatTimestamp(current.startTs)} to {Helper.formatTimestamp(current.endTs)}</span> */}
            <span className={css(Styles.spanValue, Styles.line2)}>Campaign Start: {Helper.formatTimestamp(current.startTs)}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Campaign End: {Helper.formatTimestamp(current.endTs)}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Frequency: {current.frequency}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Screens: {current.screens.length}</span>
          </div>
        )
      },
      ReviewStatus: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue, Styles.line2)}>{`Review Status (${current.reviewStatus || 'NOT SUBMITTED'})`}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>{`Campaign Status (${current.state})`}</span>
            <br/>
            {current.paymentMode !== 'MANUAL' &&
              <span className={css(Styles.spanValue, Styles.line2)}>{`Subscription Status (${current.subscriptionStatus || 'PENDING'})`}</span>
            }
            {current.paymentMode === 'MANUAL' &&
              <span className={css(Styles.spanValue, Styles.line2)}>{`Payment Status (${current.manualPaymentStatus || 'PENDING'})`}</span>
            }
            <br/>
            {current.manualPayment && current.manualPayment.amount ?
              <span className={css(Styles.spanValue, Styles.line2)}>Amount: {AppHelper.covertCentsToDollar(current.manualPayment.amount)}</span>
              :
              <span className={css(Styles.spanValue, Styles.line2)}>Amount: {AppHelper.covertCentsToDollar(current.price)}</span>
            }
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.noAdd = true
    this.noTableHead = true
  }

  onFetchSuccess(results) {
    this.fieldDefCampaignApproval = results[0].fieldDefCampaignApproval
    this.setState({
      items: results[0].items
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns', current.id]),
    });
  }

  openModalForReviewEdit(current) {
    console.log('openModalForReviewEdit:', current);
    this.formDefinition = this.fieldDefCampaignApproval
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onEdit(current);
    this.setState({
      modalOpen: true
    });
  }


  getToast() {
    return (
      <Toast open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }
  renderAboveTable() {
    return (
      <Fragment>{this.getToast()}</Fragment>
    )
  }

  onActions(current) {
    const actions = []
    actions.push(
      <Link to={this.baseRoute() + '/ss-campaigns/' + current.id + '/advertiser'} key={current.id + '-adv'}>
        <Tooltip title='Advertiser' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>group</i>
          </span>
        </Tooltip>
      </Link>
    )
    if(AppHelper.isMobileview()) {
      actions.push(
        <Tooltip title='Ads' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)} onClick={() => {
            this.setState({
              toastMsg: Helper.getString('notSupported'),
              showToast: true,
              severity: 'error'
            })
          }}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      )
    } else {
      actions.push(
        <Link to={this.baseRoute() + '/advertisers/' + current.orgId + '/campaigns/' + current.id + '?from=ss-campaigns'} key={current.id + '-media'}>
          <Tooltip title='Ads' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>playlist_play</i>
            </span>
          </Tooltip>
        </Link>
      )
    }
    actions.push(
      <Link to={this.baseRoute() + '/ss-campaigns/' + current.id + '/screens'} key={current.id + '-venues'}>
        <Tooltip title='Screens' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>tv</i>
          </span>
        </Tooltip>
      </Link>
    )
    if(['PENDING', 'APPROVED'].includes(current.reviewStatus) && (current.subscriptionStatus === 'ACTIVE' || current.manualPaymentStatus === 'PAID')) {
      actions.push(
        <Tooltip title='Review' placement='top-start' key={current.id + '-approve'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={() =>
              this.openModalForReviewEdit.bind(this)(current)
            }>flaky</i>
          </span>
        </Tooltip>
      )
    }
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    // fontSize: 14
  },
  img: {
    height: 30
  },
  line2: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/CampaignsSelfServe.js